<template>
    <div>
        <div
            class="
                flex
                lg:justify-center
                -mx-4
                mb-8
                lg:mb-16
                xl:mb-32
                overflow-auto
            "
        >
            <button
                @click="activeIndex = index"
                v-for="(item, index) in items"
                :key="index"
                :class="[
                    {
                        active: index === activeIndex,
                    },
                    `
                        relative
                        py-2
                        px-4
                        text-secondary
                        hover:text-opacity-60
                        uppercase
                        font-extrabold
                        whitespace-nowrap
                    `
                ]"
            >
                {{ item.title }}
            </button>
        </div>

        <div class="grid md:grid-cols-2 gap-6 lg:gap-24 items-start">
            <div class="-mb-6 lg:-mb-10">
                <div
                    v-for="(menuItem, index) in activeMenu.items"
                    :key="index"
                    class="mb-6 lg:mb-10"
                >
                    <h3
                        class="
                            w-full
                            flex
                            justify-between
                            pb-2
                            mb-2
                            border-b-2
                            border-dashed
                            border-gray-200
                        "
                    >
                        <span v-text="menuItem.title" />
                        <span v-text="menuItem.price" />
                    </h3>
                    <p v-text="menuItem.description" />
                </div>
            </div>
            <div class="relative highlight">
                <figure class="aspect-w-1 aspect-h-1 bg-gray-100">
                    <img
                        :src="highlight.image.url"
                        :alt="highlight.image.alt"
                        loading="lazy"
                    >
                </figure>
                <div class="p-8 pb-12">
                    <h3
                        v-text="highlight.title"
                        class="mb-2 text-gray-500 text-center"
                    />
                    <p
                        v-text="highlight.description"
                        class="text-gray-400 text-center"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MenuOverview',
    props: {
        highlight: {
            type: Object,
            default: () => {},
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            activeIndex: 0,
        };
    },
    computed: {
        activeMenu() {
            return this.items[this.activeIndex];
        },
    },
};
</script>

<style lang="scss" scoped>
    .active {
        &::before {
            @apply
                absolute
                bottom-0
                left-0
                right-0
                w-10
                mx-auto
                bg-primary;
            height: 3px;
            content: '';
        }
    }

    .highlight {
        &::before {
            @apply
                absolute
                top-5
                left-5
                z-10
                border
                border-solid
                border-gray-100;
            width: calc(100% - 40px);
            height: calc(100% - 40px);
            content: '';
            border-width: 3px;
        }
    }
</style>
